<template>
  <div class="h-400px overflow-y-auto">
    <template v-if="listaMarcas.length > 0">
      <v-list-item class="p-0 ma-0 ml-n4">
        <v-btn
          v-if="marcasMarcas.length === listaMarcas.length"
          icon
          @click="desmarcarTodasMarcas"
        >
          <v-icon color="primary">mdi-checkbox-marked</v-icon>
        </v-btn>

        <v-btn v-else icon @click="selecionarTodasMarcas">
          <v-icon v-if="marcasMarcas.length > 0" color="primary">mdi-minus-box</v-icon>
          <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
        </v-btn>

        <v-list-item-title class="font-weight-bold">{{ txtBotaoSelecionarTodos }}</v-list-item-title>
      </v-list-item>

      <v-list-item v-for="item in listaMarcas" :key="item.id" class="p-0 ma-0 ml-n4">
        <v-btn v-if="marcasMarcas.includes(item.id)" icon @click="desSelecionarMarca(item)">
          <v-icon color="primary">mdi-checkbox-marked</v-icon>
        </v-btn>

        <v-btn v-else icon @click="selecionarMarca(item)">
          <v-icon>mdi-checkbox-blank-outline</v-icon>
        </v-btn>

        <v-list-item-title :title="`${item.descricao} (${item.qtd_produto})`">
          {{ item.descricao }} ({{item.qtd_produto}})
        </v-list-item-title>
      </v-list-item>
    </template>

    <span v-else class="pl-2 text-gray-100">Não há marcas</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import api from "@/api/api";
import {logout} from "@/helpers";

export default {
  name: "Segmentos",
  props: {
    id_comprador: {
      type: [Number, String]
    }
  },
  data: () => ({
    menu: false,
    listaMarcas: [],
  }),
  computed: {
    ...mapGetters({
      fornecedorCompra: "fornecedor/getFornecedor",
      marcasMarcas: "MarcasCompra/getItens"
    }),
    txtBotaoSelecionarTodos () {
      return this.marcasMarcas.length === this.listaMarcas.length ? 'DESMARCAR TODOS' : 'MARCAR TODOS'
    }
  },
  watch: {
    fornecedorCompra () {
      this.buscarListaDeMarcas()
    }
  },
  mounted() {
    this.buscarListaDeMarcas()
  },
  destroyed() {
    this.desmarcarTodasMarcas()
  },
  methods: {
    selecionarMarca ({id}) {
      this.$store.dispatch("MarcasCompra/adicionar", id)
    },
    desSelecionarMarca ({id}) {
      this.$store.dispatch("MarcasCompra/remover", id)
    },
    selecionarTodasMarcas () {
      this.$store.dispatch(
        "MarcasCompra/adicionarTodos",
        this.Helpers.arrayColumn(this.listaMarcas, 'id')
      )
    },
    desmarcarTodasMarcas () {
      this.$store.dispatch("MarcasCompra/resetar")
    },
    buscarListaDeMarcas () {
      const params = {
        analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores,
        id_fornecedor: this.fornecedorCompra.id,
        id_comprador: this.id_comprador
      }

      api.get('fornecedores/marcas', {params})
        .then(resposta => {
          this.listaMarcas = resposta.data.marcas;
          this.selecionarTodasMarcas();
        })
        .catch(logout)
    }
  }
}
</script>
